import { CssManager } from './classes.cssmanager.js';

// lit exports
export { html, type TemplateResult, css, unsafeCSS, render, type CSSResult } from 'lit';

export { html as static, unsafeStatic } from 'lit/static-html.js';

export { unsafeHTML } from 'lit/directives/unsafe-html.js';

export { customElement } from './decorators.customelement.js';

export { property, state, query, queryAll, queryAsync } from 'lit/decorators.js';

// domtools exports
import * as domtools from '@design.estate/dees-domtools';
export { domtools };

// DeesElements exports
export * from './classes.dees-element.js';

// decorator exports
export { containerResponsive } from './decorators.containerresponsive.js';

// directives exports
import * as directives from './directives/index.js';

export { directives };

/**
 * a singleton instance of CssManager
 */
export const cssManager = CssManager.getSingleton();



// type exports
import type { rxjs } from '@push.rocks/smartrx';

export type {
  rxjs,
}